export default __webpack_public_path__ + "static/media/menu-add-item.f3249471.svg";